import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Modal, { ModalHeader, ModalBody, ModalFooter } from "../../components/modal/Modal";
import { useSettingsStore } from "../../stores/settings";

function SqlbaseAuthorizationModal({ readOnly, onAccept, onCancel }) {
  const { t } = useTranslation();
  const whitelabel = useSettingsStore((state) => state.whitelabel);
  const auftraggeberName = whitelabel?.name || "_______________";

  return (
    <Modal size="lg">
      <ModalHeader>
        <h5 className="modal-title">{t("settings.sqlbase.authorization_title")}</h5>
      </ModalHeader>
      <ModalBody>
        <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
          <p className="fw-bold mb-2">Vertragsparteien</p>
          <table className="table table-borderless table-sm mb-3">
            <tbody>
              <tr>
                <td className="fw-bold" style={{ width: "160px" }}>Auftragnehmer:</td>
                <td>ConDevTec GmbH</td>
              </tr>
              <tr>
                <td className="fw-bold">Auftraggeber:</td>
                <td>{auftraggeberName}</td>
              </tr>
            </tbody>
          </table>
          <p>
            Hiermit autorisiere ich die Einrichtung eines lesenden
            Datenbankzugriffs auf die SQLBase-Datenbank zum Zweck der
            Datenübertragung in das digitale Formular-System.
          </p>

          <h6>1. Zweck der Verbindung</h6>
          <p>
            Die Verbindung dient ausschließlich dem lesenden Zugriff auf
            Stamm- und Bewegungsdaten (Kunden, Objekte, Artikel, Artikel-Typen)
            zur Befüllung des digitalen Formular-Systems. Es werden
            keine Daten in der Quelldatenbank verändert, gelöscht oder
            hinzugefügt.
          </p>

          <h6>2. Art des Zugriffs</h6>
          <ul>
            <li>Ausschließlich lesender Zugriff</li>
            <li>Keine Schreiboperationen</li>
            <li>Keine strukturellen Änderungen</li>
          </ul>

          <h6>3. Datenhoheit</h6>
          <p>
            Der Auftraggeber versichert, dass er alleiniger Eigentümer der in
            der angebundenen Datenbank gespeicherten Daten ist bzw. über
            sämtliche erforderlichen Nutzungsrechte an diesen Daten verfügt
            und zur Weitergabe an den Auftragnehmer berechtigt ist.
          </p>

          <h6>4. Datensicherheit</h6>
          <ul>
            <li>
              Die Zugangsdaten (Datenbankname, Benutzername, Passwort) werden
              gespeichert
            </li>
            <li>
              Die Verbindung erfolgt ausschließlich über den konfigurierten
              gesicherten Tunnel
            </li>
          </ul>

          <h6>5. Verantwortlichkeit</h6>
          <p>
            Der Auftraggeber bestätigt, dass er berechtigt ist, diesen
            Datenbankzugriff zu autorisieren, und dass die erforderlichen
            internen Genehmigungen vorliegen.
          </p>

          <h6>6. Lizenzen</h6>
          <p>
            Der Auftraggeber ist für die Einhaltung sämtlicher Lizenzbedingungen der
            von ihm angebundenen Datenbanksysteme allein verantwortlich.
            Der Auftragnehmer erteilt keine Auskunft über Lizenzbedingungen von
            Drittanbietern und übernimmt hierfür keine Gewähr.
          </p>

          <h6>7. Freistellung</h6>
          <p>
            Der Auftraggeber stellt den Auftragnehmer von sämtlichen Ansprüchen frei, die
            aus der Anbindung an Datenbanksysteme Dritter resultieren,
            insbesondere aus Lizenzverletzungen.
          </p>

          <h6>8. Widerruf</h6>
          <p>
            Diese Autorisierung kann jederzeit durch Entfernen der
            Datenbankverbindungseinstellungen widerrufen werden.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <span className="text-muted me-auto" style={{ fontSize: "0.8rem" }}>
          {process.env.REACT_APP_GIT_VERSION || "dev"}
        </span>
        <button type="button" className="btn btn-default" onClick={onCancel}>
          {t("common.close")}
        </button>
        {!readOnly && (
          <button type="button" className="btn btn-success" onClick={onAccept}>
            {t("settings.sqlbase.authorization_accept")}
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

SqlbaseAuthorizationModal.propTypes = {
  readOnly: PropTypes.bool,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default SqlbaseAuthorizationModal;
